import { Fragment } from 'react';
import ReactDOM from 'react-dom';

import classes from './Modal.module.css';

const Backdrop = (props) => {
  return <div className={classes.backdrop} onClick={props.onClose}/>;
};

let mdStyle;

const mfinput = { // 동원자원입력 모달 — 대시보드 모달과 동일 (90vw, 사인보드 60px 아래)
  left: "5vw",
  width: "90vw",
  top: "calc(60px + 2vh)",
  padding: 0,
  overflow: "hidden",
  backgroundColor: "transparent",
  borderRadius: "8px",
  boxShadow: "0 3px 12px rgba(0, 0, 0, 0.2)",
}

const rdvinput = { // 지원인력 일괄입력 — 90vw 대비 30% 축소 (63vw)
  left: "18.5vw",
  width: "63vw",
  top: "calc(60px + 2vh)",
  padding: 0,
  overflow: "hidden",
  backgroundColor: "transparent",
  borderRadius: "8px",
  boxShadow: "0 3px 12px rgba(0, 0, 0, 0.2)",
}

const rdvs = { // 자원집결지관리 모달 스타일
  left: "calc(15%)",
  width: "70%",
}

const mfmsg = { // 동원자원앱 알림메시지 모달
  left: "calc(15%)",
  width: "70%",
}

const ModalOverlay = (props) => {
  return (
    <div className={classes.modal} style={mdStyle}>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};

const portalElement = document.getElementById('overlays');

const Modal = (props) => {
  // 모달 종류를 읽어서 스타일(넓이)을 변경한다.
  mdStyle =
    props.modalSort === "mfinput"
      ? mfinput
      : props.modalSort === "rdvinput"
        ? rdvinput
        : rdvs;
  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop onClose={props.onClose} />, portalElement)}
      {ReactDOM.createPortal(<ModalOverlay>{props.children}</ModalOverlay>,portalElement)}
    </Fragment>
  );
};

export default Modal;
